import type { VerdictPreviewSastGuidanceAPI } from "@/api/useSettings.types"

export const getDescription = (values: VerdictPreviewSastGuidanceAPI) =>
  values.isFalsePositive
    ? values.falsePositiveReason
    : values.llmIssueDescription
